var path = '/account/sidepanel/accountDetails/accountDetailsTabOverview/accountDetailsTabOverview.tpl.html';
var html = " <dl class=\"account-details dl-horizontal\"> <dt data-ng-repeat-start=\"field in ::accountDetailsTabOverviewController.grouping | orderBy:'order':false \" class=dt-key data-ng-attr-title={{::field.label}} data-ng-bind-html=::field.label> </dt> <dd data-ng-repeat-end class=dt-value data-ng-class=\"::{'alert-danger joint': field.jointType }\"> <span data-ng-bind-html=::field.value></span> </dd> </dl> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./WebContent/src/account/sidepanel/accountDetails/accountDetailsTabOverview/accountDetailsTabOverview.tpl.html
// module id = 669
// module chunks = 0 2